// src/pages/PrivacyPolicy.tsx
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen p-6 bg-background">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-4xl font-bold tracking-tight">Privacy Policy</h1>
        <div className="prose prose-invert max-w-none">
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <h2>1. Information We Collect</h2>
          <p>We collect information that you provide directly to us when using the Screen Tool, including:</p>
          <ul>
            <li>Color preferences</li>
            <li>Resolution settings</li>
            <li>Usage data</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and improve our services</li>
            <li>Analyze usage patterns</li>
            <li>Enhance user experience</li>
          </ul>

          <h2>3. Data Security</h2>
          <p>We implement appropriate security measures to protect your information.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;